export function normalizeToken(raw = "") {
  return String(raw)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s._-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function buildSearchTokens({ displayName = "", publicHandle = "", userName = "", email = "", custom = [] } = {}) {
  const base = [displayName, publicHandle, userName, email, ...(Array.isArray(custom) ? custom : [])]
    .map(normalizeToken)
    .filter(Boolean);

  const tokens = new Set();

  base.forEach((entry) => {
    tokens.add(entry);

    entry.split(/[\s._-]+/).forEach((part) => {
      if (part) tokens.add(part);
    });

    if (entry.length > 2) {
      for (let i = 3; i <= Math.min(entry.length, 20); i += 1) {
        tokens.add(entry.slice(0, i));
      }
    }
  });

  return Array.from(tokens).slice(0, 200);
}
